/**
 * Dispatch Page
 *
 * Main dispatch board for managing job assignments and driver dispatch
 *
 * Features:
 * - Stream 1 Dispatch Board with drag-and-drop
 * - Driver column management
 * - Job assignment operations
 */

import { DispatchBoard } from '@/features/dispatch/components/DispatchBoard';

export function DispatchPage() {
  return (
    <div className="container mx-auto py-6">
      <DispatchBoard />
    </div>
  );
}
